import { NotesTabAction, NotesTabState } from './interfaces';

// TODO: use a shared reducer
export const getNotesInitialState: <T>() => NotesTabState<T> = () => ({
  crud: { open: false, record: null, mode: null },
  deleteModal: { open: false, record: null },
});

export function notesReducer<T>(prevState: NotesTabState<T>, action: NotesTabAction<T>): NotesTabState<T> {
  switch (action.type) {
    case 'openCrud':
      if (!action.mode) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...getNotesInitialState(),
        crud: { open: true, record: action.record ?? null, mode: action.mode },
      };
    case 'closeCrud':
      return {
        ...getNotesInitialState(),
      };
    case 'openDeleteModal':
      if (!action.record) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        deleteModal: {
          open: true,
          record: action.record,
        },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: false,
          record: null,
        },
      };
    default:
      throw new Error('No action provided');
  }
}
